import { Injectable } from '@angular/core';
import { CanMatch, Route } from '@angular/router';
import { LocaleService } from '@shared/lib/services/locale.service';
import { UsanaMarketService } from '@usana/ux/markets';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CmsTypeGuard implements CanMatch {
  constructor(
    private readonly localeService: LocaleService,
    private readonly usanaMarketService: UsanaMarketService,
  ) {}

  async canMatch(route: Route): Promise<boolean> {
    await firstValueFrom(this.usanaMarketService.geti18NInfoSubject());
    await firstValueFrom(this.localeService.getLocaleObservable());
    const isCms = this.localeService.isCms();
    if (route.data?.cmsType === 'cms') {
      return isCms;
    }
    if (route.data?.cmsType === 'noncms') {
      return !isCms;
    }

    return true;
  }
}
